import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { matchPath } from 'react-router-dom';
import {
  View,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { signUp } from '@aws-amplify/auth';
import md5 from 'md5';

import styles from '../../styles';
import SignUpForm from '../../components/forms/user/SignUpForm';
import { locale, country, language } from '../../localization';
import { currency } from '../../money';
import AORTypes from '../../types';

class SignUp extends React.Component {
  static async storeEmail(email) {
    if (!email) {
      return;
    }

    try {
      await AsyncStorage.setItem('email', email);
      console.log('storeEmail succeeded');
    } catch (error) {
      // Error saving data
      console.log('storeEmail failed');
    }
  }

  static async storePassword(password) {
    if (!password) {
      return;
    }

    try {
      await AsyncStorage.setItem('password', password);
    } catch (error) {
      // Error saving data
    }
  }

  static validateUsername(username) {
    return (username.length >= 4);
  }

  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'SignUp';

    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
    };
  }

  componentDidMount() {
    const { user, history } = this.props;
    const redirect = this.getRedirect();

    if (user && user.username) {
      if (user.attributes.email_verified) {
        history.push(redirect);
      } else {
        history.push(`/confirm${redirect}`);
      }
    }
  }

  componentDidUpdate(_prevProps) {
    const { user, history } = this.props;
    const redirect = this.getRedirect();

    if (user && user.username) {
      if (user.attributes.email_verified) {
        history.push(redirect);
      } else {
        history.push(`/confirm${redirect}`);
      }
    }
  }

  async onSubmit(values) {
    const { history, getAnalyticsService } = this.props;
    const redirect = this.getRedirect();
    // const { email, name, password } = values;
    const { password } = values;
    let { email } = values;

    email = email.trim();

    console.log('attempting');
    // console.log(values);

    return signUp({
      username: md5(email),
      password,
      options: {
        userAttributes: {
          // given_name: name,
          // family_name: '',
          email,
          locale,
          'custom:country': country,
          'custom:language': language(),
          'custom:currency': currency,
        },
        autoSignIn: true,
      },
      // validationData: [], // optional
    })
      .then((data) => {
        console.log('success');
        console.log(data);

        const p1 = SignUp.storeEmail(email).catch(() => null);
        const p2 = SignUp.storePassword(password).catch(() => null);

        getAnalyticsService().report.event('sign_up', 'user', '', '');

        Promise.all([p1, p2]).then(() => {
          history.push(`/confirm${redirect}`);
        });

        return null;
      })
      .catch((err) => {
        console.log('failure');
        console.log(err.message);
        getAnalyticsService().report.error(err);

        return err.message;
      });
  }

  getRedirect() {
    const { location } = this.props;
    const match = matchPath('/signup/:redirect', location.pathname);
    return match ? `/${match.params.redirect}` : '/';
  }

  render() {
    const { history } = this.props;
    const redirect = this.getRedirect();

    return (
      <View style={styles.view.headed}>
        <SignUpForm
          redirect={redirect}
          history={history}
          onSubmit={this.onSubmit}
        />
      </View>
    );
  }
}

SignUp.defaultProps = {
  user: undefined,
};

SignUp.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  user: AORTypes.User,
};

export default SignUp;
